/**
 * Formate un nombre en notation abrégée (K, M, B)
 * @param value - Le nombre ou string à formater
 * @param decimals - Nombre de décimales (défaut: 1)
 * @returns Le nombre formaté (ex: 1.2k, 3.5M)
 */
export const formatNumber = (
  value: number | string,
  decimals: number = 1
): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value

  if (isNaN(num)) return '0'
  if (num === 0) return '0'

  const abs = Math.abs(num)
  const sign = num < 0 ? '-' : ''

  if (abs >= 1_000_000_000) {
    return (
      sign + (abs / 1_000_000_000).toFixed(decimals).replace(/\.0$/, '') + 'B'
    )
  }

  if (abs >= 1_000_000) {
    return sign + (abs / 1_000_000).toFixed(decimals).replace(/\.0$/, '') + 'M'
  }

  if (abs >= 1_000) {
    return sign + (abs / 1_000).toFixed(decimals).replace(/\.0$/, '') + 'k'
  }

  return sign + abs.toString()
}
